import '@splidejs/splide/css'
import Splide from '@splidejs/splide'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all'
// import { TextPlugin } from 'gsap/all'

import { wfSliderArrows, wfTabs, addSplideClasses, sel, selAll, addStaticSplideClasses, selector, mm, splideCarousel, stLineWrap } from './utils'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import SplitType from 'split-type'

gsap.registerPlugin(ScrollTrigger)

export default function About() {
  console.log('about')

  const navbar$ = sel('.navbar')
  const hero$ = sel('.case-hero')
  const heroC$ = sel('.lp-hero__c')
  const heroInfo$ = sel('.lp-hero__info')
  const heroH$ = sel('.product-header__h')
  const heroP$ = sel('.header__p')
  const heroBtnW$ = sel('.product-header .btn-w')
  const heroImgW$ = sel('.product-header__img-w')
  // const heroImg$ = heroImgW$.querySelector('.img-a')
  const heroLogo$ = sel('.case-hero__img__logo')

  const heroHsT = new SplitType(heroH$, { types: 'words, chars' })
  const heroPsT = new SplitType(heroP$, { types: 'lines' })
  stLineWrap(heroPsT.lines)

  const heroTl = gsap.timeline({ defaults: { ease: 'power4.out', duration: 1 } })
  heroTl
    .from(
      heroHsT.chars,
      {
        opacity: 0,
        filter: 'blur(50px)',
        stagger: {
          amount: 0.5,
        },
        duration: 0.75,
      },
      0.5
    )
    .from(heroBtnW$, { y: 20, opacity: 0 }, 1.5)
    .from(heroPsT.lines, { yPercent: 110, stagger: { amount: 0.2 } }, 1)
    .from(heroImgW$, { x: 20, opacity: 0, duration: 2.5 }, 1.5)
    .from(navbar$, { opacity: 0, duration: 3 }, 2)

  const featuresHeader$ = selAll('.product-title')
  ;[...featuresHeader$].forEach((header) => {
    // console.log(header)

    const s$ = header.querySelector('.product-title__eyebrow')
    const h$a = header.querySelectorAll('h2')
    const hSt = new SplitType(h$a, { types: 'lines', linesClass: 'st-line' })
    stLineWrap(hSt.lines)
    const tl = gsap
      .timeline({ defaults: { ease: 'power4.out', duration: 1 } })
      .from(hSt.lines, { yPercent: 110, stagger: { amount: 0.1 } }, 0)
      .from(s$, { opacity: 0 }, 0.4)
    ScrollTrigger.create({
      trigger: header,
      start: 'top 50%',
      animation: tl,
    })
  })

  // Our Why
  const whyItem$a = selAll('.product-p-img__lo>div')
  gsap.from(whyItem$a, {
    scrollTrigger: {
      trigger: whyItem$a[0],
      start: 'top 75%',
    },
    x: 50,
    opacity: 0,
    stagger: {
      amount: 0.2,
    },
    ease: 'power4.out',
    duration: 1.2,
  })

  // Team
  const teamItem$a = selAll('.our-team__item-w')
  gsap.from(teamItem$a, {
    scrollTrigger: {
      trigger: teamItem$a[0],
      start: 'top 75%',
    },
    y: 50,
    opacity: 0,
    stagger: {
      amount: 0.4,
    },
    ease: 'power4.out',
    duration: 1.5,
  })

  // Team CTA

  const cta$ = sel('.features__info')
  const ctaH$ = cta$.querySelector('h3')
  const ctaP$ = cta$.querySelector('p')
  const ctaBtn$ = cta$.querySelector('.button-group')

  const ctaTl = gsap
    .timeline({ defaults: { ease: 'power4.out', duration: 2 }, paused: true })
    //
    .from([ctaH$, ctaP$, ctaBtn$], { y: 50, opacity: 0, stagger: 0.15 }, 0)
  ScrollTrigger.create({
    trigger: cta$,
    start: 'top 50%',
    animation: ctaTl,
  })

  // Studies
  const studies$a = selAll('.overview-case__lo>*')
  gsap.from(studies$a, {
    scrollTrigger: {
      trigger: studies$a[0],
      start: 'top 75%',
    },
    y: 50,
    opacity: 0,
    stagger: {
      amount: 0.2,
    },
    ease: 'power4.out',
    duration: 1.2,
  })

  // Services
  const services$a = selAll('.product-value__lo>*')
  gsap.from(services$a, {
    scrollTrigger: {
      trigger: services$a[0],
      start: 'top 75%',
    },
    y: 50,
    opacity: 0,
    stagger: {
      amount: 0.2,
    },
    ease: 'power4.out',
    duration: 1.2,
  })

  const formLo$ = sel('.new-form__lo')
  const formLo$a = selAll('.new-form__lo>div')
  gsap.from(formLo$a, {
    scrollTrigger: {
      trigger: formLo$,
      start: 'top 75%',
    },
    x: 50,
    opacity: 0,
    stagger: {
      amount: 0.2,
    },
    ease: 'power4.out',
    duration: 1.2,
  })
}
